import gsap from 'gsap';
import type { Keyframe } from '../types';
import { getLastKeyframeFrame } from './timeline';

export interface EditorPlaybackTimelineOptions {
  /** Store'daki keyframes haritası — son keyframe karesi oynatma bitişi için kullanılır */
  keyframes: Record<string, Keyframe[]>;
  totalFrames: number;
  /** Oynatmanın başladığı kare */
  startFrame: number;
  fps: number;
  setFrame: (frame: number) => void;
  onComplete: () => void;
}

/**
 * Editor timeline verisine göre playhead'i GSAP timeline ile ilerletir.
 * Kare güncellemeleri mevcut TimelineFrames interpolasyonunu (tween/KeyframeState) tetikler.
 */
export function createEditorPlaybackTimeline(
  options: EditorPlaybackTimelineOptions
): gsap.core.Timeline | null {
  const { keyframes, totalFrames, startFrame, fps, setFrame, onComplete } = options;

  const lastKf = getLastKeyframeFrame(keyframes);
  if (lastKf === null) {
    onComplete();
    return null;
  }

  const playEnd = Math.min(lastKf, Math.max(0, totalFrames - 1));

  if (startFrame >= playEnd) {
    setFrame(playEnd);
    onComplete();
    return null;
  }

  const proxy = { p: 0 };
  const span = playEnd - startFrame;

  const tl = gsap.timeline({ onComplete }).to(proxy, {
    p: 1,
    duration: span / fps,
    ease: 'none',
    onUpdate: () => {
      const t = proxy.p >= 1 ? 1 : proxy.p;
      const frame = Math.round(startFrame + t * span);
      setFrame(Math.min(playEnd, Math.max(startFrame, frame)));
    },
  });

  return tl;
}
